import http from '../../../utils/fetch'
import updownfile from '../../../utils/updownfile'

export default {

    baseurl: '/api/swyl/v1/lk/special',

    // ==================== 列表 & 导出 ====================

    /**
     * 朗康特价列表分页查询（复用现有接口）
     */
    listPage(q) {
        return http({
            url: '/api/swyl/v1/special/offer/listPage',
            method: 'post',
            params: q
        })
    },

    /**
     * 朗康特价导出（新接口，含订单流程字段 + 8列上传状态）
     */
    downloadExcel(q) {
        updownfile.down(this.baseurl + '/downloadExcel', q, 'post')
    },

    // ==================== 订单详情 ====================

    /**
     * 根据特价版本号查询订单列表
     */
    getOrderListBySpecialId(specialId) {
        return http({
            url: this.baseurl + '/getOrderListBySpecialId',
            method: 'post',
            params: { specialId }
        })
    },

    // ==================== 补传 ====================

    /**
     * 补传文件
     * @param {Object} q - { specialId, files[], reftype }
     */
    supplementUpload(q) {
        return http({
            url: this.baseurl + '/supplementUpload',
            method: 'post',
            params: q
        })
    },

    // ==================== 逾期校验 ====================

    /**
     * 校验代理商是否存在逾期未补传的特价
     * @param {String} contactAgent
     */
    checkOverdue(contactAgent) {
        return http({
            url: this.baseurl + '/checkOverdue',
            method: 'post',
            params: { contactAgent }
        })
    },

    // ==================== 8 种文件上传状态 ====================

    /**
     * 查询指定特价的 8 种文件上传状态
     * @param {String} specialId
     */
    getFileStatus(fileid) {
        return http({
            url: this.baseurl + '/getFileStatus',
            method: 'post',
            params: { fileid }
        })
    },

    // ==================== 延期审批页 ====================

    /**
     * 延期审批页加载特价信息（含延期字段）
     * @param {String} specialId
     */
    getExtensionDetail(specialId) {
        return http({
            url: this.baseurl + '/getExtensionDetail',
            method: 'post',
            params: { specialId }
        })
    },

    // ==================== 延期申请 (2026.07) ====================

    /**
     * 发起延期申请
     * @param {Object} q - { specialId, extensionDate, fileid }
     */
    applyExtension(q) {
        return http({
            url: this.baseurl + '/applyExtension',
            method: 'post',
            params: q
        })
    },

    /**
     * 延期审批（通过/驳回）
     * @param {Object} q - { specialId, taskid, optflag, msg }
     */
    approveExtension(q) {
        return http({
            url: this.baseurl + '/approveExtension',
            method: 'post',
            params: q
        })
    }

}
